// Libs
import when from 'when'
import Emitter from 'event-emitter'
import glmat from 'gl-matrix'

// Strcutral
import SceneAbs from '../abstract/scene'
import Camera from '../utils/camera'
import TextureLoader from '../utils/textureLoaderObject'
import Manifest from '../manifest'

// Entities
import Plane from '../entities/planeCover'

// Post
import PostMarbling from '../postProcess/marblingDisplacement'

// Utils
import RAF from '@/js/utils/raf'
import DebugController from '@/glxp/debug/debugController'

let mat4 = glmat.mat4
let vec3 = glmat.vec3
let vec2 = glmat.vec2

const _VEC2 = vec2.create()

var _emitter = {}
Emitter(_emitter)

class PartnerScene extends SceneAbs {
  constructor (container, manager = null) {
    super(container, manager)

    // console.log((Math.abs((window.innerWidth / window.innerHeight) - 1)) + 1)
    // this.fovFactor = 1.5
    // console.log(1 / (window.innerHeight / window.innerWidth))
    // console.log(1 / (window.innerWidth / window.innerHeight))
    // this.fovFactor = Math.min(1.5, Math.max(0.75, 1 / (window.innerWidth / window.innerHeight)))
    this.fovFactor = 1
    const h = window.innerHeight
    if (h > 2000) this.fovFactor = 1.5
    else if (h > 1800) this.fovFactor = 1.4
    else if (h > 1600) this.fovFactor = 1.35
    else if (h > 1400) this.fovFactor = 1.3
    else if (h > 1200) this.fovFactor = 1.25
    else if (h > 1000) this.fovFactor = 1.2
    else if (h > 900) this.fovFactor = 1.1
    else if (h > 800) this.fovFactor = 1
    else if (h > 700) this.fovFactor = 0.9
    else if (h > 600) this.fovFactor = 0.8
    else if (h > 500) this.fovFactor = 0.7
    else this.fovFactor = 0.75
    console.log(this.fovFactor)

    this.camera = new Camera(this, 30 * this.fovFactor)
    this.camera.node.position[2] = -6
    this.shakeFactor = 0
    this.shakeFactorTarget = 0
    this.step = 0
    this.stepTarget = 0
    this.focus = 0
    this.focusTarget = 0
    this.cursor = vec2.create()
    this.cursorTarget = vec2.create()
    this.lastCursor = vec2.create()
    this.velocity = vec2.create()
    this.scrollVelocity = vec2.create()
    this.imageSize = 1

    this.clearColor = [0, 0, 0, 0]

    this.images = []
    this.padding = 0

    this.mobile = false
    this.isDragging = false
    this.focused = false
    this.loaded = false

    this.textureLoader = new TextureLoader(this)
    this.postMarbling = new PostMarbling(this)

    this.config = {
      shake_damping: { value: 0.3, range: [0, 0.1] },
      cursor_damping: { value: 0.1, range: [0, 0.1] },
      focus_damping: { value: 0.06, range: [0, 0.1] },
      focus_zoom: { value: 1, range: [0, 10] },
      radius_mutiplicator: { value: 2.5, range: [0, 5] },
      size_influence: { value: 1, range: [0, 2] },
      speed_influence: { value: 3, range: [0, 10] },
      fade_factor: { value: 2.5, range: [0, 5] },
      stiffness: { value: 0.1, range: [0, 1] }
    }

    DebugController.addConfig(this.config, 'PartnersScene')

    this.postMarbling.pass.customParams = this.config

    this.initEvents()
  }

  onLoaded () {
    this.active = true
    this.loaded = true

    this._emitter.emit('loaded')
    for (let i = 0; i < this.images.length; i++) {
      const img = this.images[i]
      img.mesh = new Plane(this, img.id, img.id, 'cover')
    }
  }

  start () {
    // this.shakeFactor = .05
  }

  initEvents () {
    window.addEventListener('mousemove', (event) => {
      this.cursorTarget[0] = event.clientX / ((this.width / this.dpr))
      if (!this.isDragging) {
        this.cursorTarget[1] = event.clientY / ((this.height / this.dpr))
      }
    })

    window.addEventListener('mousedown', (event) => {
      this.postMarbling.pass.useCustomParams = true
      this.isDragging = true
    })

    window.addEventListener('mouseup', (event) => {
      this.postMarbling.pass.useCustomParams = false
      this.isDragging = false
    })
  }

  reset () {
    // this.images.length = 0
    // this.mesh.length = 0
  }

  addImage (id, url) {
    if (this.loaded == false) {
      this.images.push({ id, url, opacity: 0, offset: vec2.create(), visibility: true })
    }
  }

  setVisibility (id, visibility) {
    this.images[id].visibility = visibility
  }

  setTranslate (id, x, y) {
    this.images[id].offset[0] = x
    this.images[id].offset[1] = y
  }

  setOpacity (id, opacity) {
    this.images[id].opacity = opacity
  }

  load () {
    this.active = false

    let loadables = []
    for (let i = 0; i < this.images.length; i++) {
      const img = this.images[i]
      loadables.push(this.textureLoader.load(img.url, img.id, []))
    }

    when.all(loadables).then(() => {
      this.onLoaded()
    })

    let percent = 0
    for (let i = 0; i < loadables.length; i++) {
      loadables[i].then(() => {
        percent++
        this._emitter.emit('progress', Math.round((percent / loadables.length) * 100))
      })
    }
  }

  applyDefaultState () {
    let gl = this.gl
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA)
    gl.enable(gl.BLEND)
    gl.enable(gl.DEPTH_TEST)
    // gl.disable(gl.CULL_FACE)
  }

  // Pre-render
  preRender () {
    let gl = this.gl

    this.velocity[0] = this.cursorTarget[0] - this.lastCursor[0]
    this.velocity[1] = this.cursorTarget[1] - this.lastCursor[1]
    this.lastCursor[0] = this.cursorTarget[0]
    this.lastCursor[1] = this.cursorTarget[1]

    vec2.sub(_VEC2, this.cursorTarget, this.cursor)
    vec2.scale(_VEC2, _VEC2, this.config.cursor_damping.value)
    vec2.add(this.cursor, this.cursor, _VEC2)

    this.shakeFactorTarget = Math.max(vec2.length(this.velocity), 0.03)
    let tmp = this.shakeFactorTarget - this.shakeFactor
    tmp *= this.config.shake_damping.value
    this.shakeFactor += tmp

    if (this.focused) {
      this.focusTarget = this.config.focus_zoom.value
    } else {
      this.focusTarget = 0
    }

    tmp = this.focusTarget - this.focus
    tmp *= this.config.focus_damping.value
    this.focus += tmp

    this.camera.node.position[2] = -(6 + this.focus)
    this.camera.node.needUpdate = true

    this.camera.updateProjection(this.width / this.height)

    this.postMarbling.pass.customShift = -this.scrollVelocity[0] * 0.6
    this.postMarbling.pass.customShiftWidth = 0.6
  }

  // Render
  render () {
    if (!this.active) { return }

    this.time += RAF.dt / 1000
    this.dt = RAF.dt

    let gl = this.gl

    gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3])
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
    gl.colorMask(true, true, true, true)

    this.preRender()
    gl.viewport(0, 0, this.width, this.height)

    // Render Time

    this.postMarbling.preRender()
    // let ratio = (50 * this.width) / (60 * this.height)
    // let ratio = (45 * this.width) / (45 * this.width * 0.66) * this.config.size_influence.value
    let ratio = (45 * this.width) / (45 * this.width * 0.66) * this.imageSize
    for (let i = 0; i < this.images.length; i++) {
      let mesh = this.images[i].mesh
      mesh.node.position[0] = this.images[i].offset[0] * ((this.width / this.dpr) / 255)
      mesh.node.position[1] = this.images[i].offset[1]
      mesh.node.scale[0] = ratio
      // mesh.node.scale[1] = this.config.size_influence.value
      mesh.node.scale[1] = this.imageSize
      mesh.node.needUpdate = true
      mesh.opacity = this.images[i].opacity * this.config.fade_factor.value
      if (this.images[i].visibility == true) {
        mesh.render()
      }
    }
    this.postMarbling.postRender()

    this.postMarbling.render()

    this.postRender()
  }

  getCanvas () {

  }

  postRender () {
    this.gl.viewport(0, 0, this.width, this.height)
    // this.grain.render()
  }
}
export default PartnerScene
